export const environment = {
  roleAdministrator: 'Administrator',
  production: true,
  envName: 'DEV',
  apiEndpoint: 'https://cot-dta-campos-api-dev-bgdkfreyfma4bbah.eastus-01.azurewebsites.net/api/',
  azureAd: {
    authority: 'https://login.microsoftonline.com/e365ef77-5132-4232-8ab9-c97057b68043',
    clientId: '8f626114-6077-4084-9353-d6b626fc5146',
    redirectUri: '/',
    postLogoutRedirectUri: 'https://campos.dev.glubatec.com/#/login',
    graphEndpoint: 'https://graph.microsoft.com/v1.0/me'
  },
};
